import { ImageOff } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";

function Field({ label, value }) {
  return (
    <div>
      <p className="text-xs font-semibold uppercase tracking-wider text-[#525252] mb-1">
        {label}
      </p>
      <p className="text-sm text-[#0A0A0A] break-words">
        {value ? value : <span className="text-[#A3A3A3]">—</span>}
      </p>
    </div>
  );
}

function formatDate(iso) {
  if (!iso) return "";
  if (!/\d{4}-\d{2}-\d{2}/.test(iso)) return iso;
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

export default function ViewCylinderDialog({
  open,
  onOpenChange,
  cylinder,
  capacityMap,
}) {
  if (!cylinder) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Cylinder — {cylinder.fuel_access_sticker_value}</DialogTitle>
          <DialogDescription>
            QR Code: <b>{cylinder.qr_code}</b>
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <Field label="Cylinder Serial Number" value={cylinder.cylinder_serial_number} />
          <Field label="Sticker Prefix" value={cylinder.prefix_name} />
          <Field label="Fuel Access Sticker Value" value={cylinder.fuel_access_sticker_value} />
          <Field label="Cylinder Manufacturer Name" value={cylinder.cylinder_manufacturer_name} />
          <Field label="Cylinder Manufacturer Year" value={cylinder.cylinder_manufacturer_year} />
          <Field label="Expiry Year" value={cylinder.expiry_year} />
          <Field label="Last Test Date" value={formatDate(cylinder.last_test_date)} />
          <Field label="Due Test Date" value={formatDate(cylinder.due_test_date)} />
          <Field
            label="Cylinder Capacity"
            value={capacityMap?.[cylinder.cylinder_capacity_id]}
          />

          <div className="sm:col-span-2">
            <p className="text-xs font-semibold uppercase tracking-wider text-[#525252] mb-2">
              Cylinder Image
            </p>
            {cylinder.cylinder_image ? (
              <img
                src={cylinder.cylinder_image}
                alt="Cylinder"
                className="max-h-56 rounded-md border border-black/10 bg-[#FAFAFA] object-contain"
              />
            ) : (
              <div className="inline-flex items-center gap-2 text-sm text-[#A3A3A3]">
                <ImageOff className="h-4 w-4" />
                No image
              </div>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
